import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import imageError from 'app/shared/images/imageError.png';

import BackgroundImage from 'app/shared/components/photos/BackgroundImage';

import { StyledImageContainer } from './StyledComponents';

const propTypes = {
    altText: PropTypes.string,
    image: PropTypes.string,
    isBackgroundImage: PropTypes.bool,
    onImageLoading: PropTypes.func,
    imgErrorSrc: PropTypes.string,
    backgroundSize: PropTypes.string,
};

const defaultProps = {
    altText: 'Thumbnail image',
    image: '',
    onImageLoading: null,
    imgErrorSrc: imageError,
    isBackgroundImage: false,
    backgroundSize: 'cover',
};

class ImageContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isInitialImage: true,
            backgroundSize: this.props.backgroundSize,
            src: this.props.image,
        };
    }

    componentDidMount() {
        const { image } = this.props;

        if (image) {
            this.createLoader();
        }
    }

    componentWillReceiveProps(nextProps) {
        // new image url is getting passed to the component
        // happens with photo gallery forward/back

        if (nextProps.image !== this.props.image) {
            this.setState({ src: nextProps.image }, () => this.createLoader());
        }
    }

    createLoader() {
        const { imgErrorSrc, onImageLoading } = this.props;
        const { src } = this.state;
        const img = new Image();

        if (imgErrorSrc) {
            img.onerror = () => {
                this.setState({ src: imgErrorSrc, isLoading: false, backgroundSize: 'contain' });
            };
        }

        if (onImageLoading) {
            this.setState({ isLoading: true, isInitialImage: false });

            img.onload = () => {
                this.setState({ isLoading: false });
            };
        }

        img.src = src;
    }

    renderLoading() {
        const { onImageLoading } = this.props;
        const { isLoading, isInitialImage } = this.state;

        if (!isInitialImage && isLoading && onImageLoading) {
            return onImageLoading;
        }

        return null;
    }

    render() {
        const {
            altText, isBackgroundImage, style, onClick, onKeyDown,
        } = this.props;
        const { backgroundSize, src } = this.state;

        return (
            <StyledImageContainer className="ImageContainer" style={{ ...style }}>
                {this.renderLoading()}
                {isBackgroundImage ? (
                    <BackgroundImage
                        backgroundSize={backgroundSize}
                        src={src}
                        altText={altText}
                        onClick={onClick}
                        onKeyDown={onKeyDown}
                    />
                ) : (
                    <img alt={altText} src={src} />
                )}
            </StyledImageContainer>
        );
    }
}

ImageContainer.propTypes = propTypes;
ImageContainer.defaultProps = defaultProps;

export { ImageContainer };
export default connect()(ImageContainer);
